module.exports = __webpack_public_path__ + "img/CTA and Footer.4883e90e.png";